const distributorsApiFactory = (axios) => ({
  getDistributorContacts: async (distributorId) => (await axios.get(`/distributors/${distributorId}/distributor-contacts`)).data,
});

export { distributorsApiFactory };
